var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEpic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#7C5BA6;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.9,0.9h-10c-1.1,0-2,0.9-2,2v10c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2v-10C14.9,1.8,14,0.9,12.9,0.9z  M10.8,7.6l-2,3.9c0,0,0,0,0,0.1l0,0l0,0c-0.1,0.1-0.2,0.2-0.4,0.2c-0.3,0-0.5-0.2-0.5-0.5V8.9H5.4c-0.3,0-0.5-0.2-0.5-0.5 c0-0.1,0-0.2,0.1-0.3l0,0l1.9-3.9c0,0,0-0.1,0.1-0.1C7.1,4,7.2,3.9,7.4,3.9c0.3,0,0.5,0.2,0.5,0.5v2.5h2.5c0.3,0,0.5,0.2,0.5,0.5 C10.9,7.5,10.9,7.6,10.8,7.6L10.8,7.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpic);
export default __webpack_public_path__ + "static/media/epic.b1436c733b4510a15706c206a752b2b6.svg";
export { ForwardRef as ReactComponent };